export default {
  title: 'فرم محصول',
  detail: 'ایجاد و ویرایش  اطلاعات محصول',


  name_fa : 'نام فارسی',
  name_en: 'نام لاتین',
  price_irr: 'قیمت ریال',
  price_usd: 'قیمت دلار',
  stock_total: 'کل موجودی',
  stock_reserved: 'موجودی رزروی',
  stock_visible: 'موجودی نمایشی',
  description_fa: 'توضیحات فارسی',
  description_en: 'توضیحات انگلیسی',
  category:'دسته بندی',
  is_book:'کتاب هست؟',
  chapters:'سرفصل',
  media:'رسانه',
  images:'تصاویر',
  yes:'بله',
  no:'خیر',
  status: 'وضعیت',
  statusActive: 'فعال',
  statusInActive: 'غیرفعال',
  back : 'لغو',
  success : 'موفق',
  error : 'خطا',
  save : 'ذخیره',
  loading : 'در حال بارگزاری',
  saving : 'در حال بارگزاری ...',

  placeholderNameFa: 'نام فارسی را وارد نماید',
  placeholderNameEn: 'نام لاتین را وارد نماید',
  placeholderPriceIrr: 'قیمت ریال را وارد نماید',
  placeholderPriceUsd: 'قیمت دلار را وارد نماید',
  placeholderStockTotal: 'موجودی کل را وارد نماید',
  placeholderDescriptionFa: 'توضیحات فارسی را وارد نماید',
  placeholderDescriptionEn: 'توضیحات لاتین را وارد نماید',
  placeholderCategory: ' دسته بندی را وارد نماید',
  placeholderIsBook: 'این محصول کتاب می باشد',

}
